import React from "react";
import clsx from "clsx";

import Portal from "../Portal";

import styles from "./ActionBubbleModal.module.scss";
type ActionBubbleModalProps = {
  className?: string;
  onClose: () => void;
  children: React.ReactNode;
};

const ActionBubbleModal = React.forwardRef<
  HTMLDivElement,
  ActionBubbleModalProps
>(({ className, children, onClose }, ref) => {
  return (
    <Portal>
      <div className={styles.modal}>
        <div className={styles.modal__backDrop} onClick={onClose} />

        <div ref={ref} className={clsx(styles.modal__content, className)}>
          {children}
        </div>
      </div>
    </Portal>
  );
});

export default ActionBubbleModal;
